module.exports = __webpack_public_path__ + "media/images/CLR_for_Students_logo_200x186-6d0ce613c924fbe11b1dc51569f5469b.png";